import { render, staticRenderFns } from "./TheWelcomeDonations.vue?vue&type=template&id=259ff253&scoped=true&"
import script from "./TheWelcomeDonations.vue?vue&type=script&lang=ts&"
export * from "./TheWelcomeDonations.vue?vue&type=script&lang=ts&"
import style0 from "./TheWelcomeDonations.vue?vue&type=style&index=0&id=259ff253&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259ff253",
  null
  
)

export default component.exports